(function(){
 function init(root){
   if(root.dataset.ready)return;root.dataset.ready='true';
   var reportLanguageChosen=false;
   root.addEventListener('change',function(event){
     if(event.target.matches('[data-cr-report-language]'))reportLanguageChosen=true;
   });
   function show(lang,updateUrl){
     root.lang=lang==='zh'?'zh-Hans':'en';
     root.querySelectorAll('[data-copy]').forEach(function(el){el.hidden=el.dataset.copy!==lang;});
     root.querySelectorAll('[data-page-language]').forEach(function(el){el.setAttribute('aria-pressed',String(el.dataset.pageLanguage===lang));});
     // Match the landing link until the visitor explicitly chooses a report language.
     if(!reportLanguageChosen){
       root.querySelectorAll('[data-cr-report-language]').forEach(function(select){
         select.value=lang==='zh'?'Mandarin (Simplified Chinese)':'English';
       });
     }
     if(updateUrl){
       var url=new URL(location.href);url.searchParams.set('lang',lang);
       history.replaceState(history.state,'',url);
     }
   }
   root.querySelectorAll('[data-page-language]').forEach(function(button){button.addEventListener('click',function(){show(button.dataset.pageLanguage,true);});});
   show(new URLSearchParams(location.search).get('lang')==='zh'?'zh':'en',false);
 }
 document.querySelectorAll('[data-cr-one-question]').forEach(init);
 document.addEventListener('shopify:section:load',function(){document.querySelectorAll('[data-cr-one-question]').forEach(init);});
})();
